import { getItemFromCollection } from "directus/src/operations";

export async function fetchSurveyData({ surveyId }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        "job",
        "questions.id",
        "questions.question",
      ],
    };
    const response = await getItemFromCollection("surveys", surveyId, query);

    const data = {
      ...response,
      jobs: response.jobs.map((item) => item.job.id),
      questions: response.questions.map((item) => item.question),
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
